import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import CompanyRegistrationHeader from '../components/Service/InternationalCompetition/CompanyRegistrationHeader';
import CompanyRegistrationInfo from '../components/Service/InternationalCompetition/CompanyRegistrationInfo';
import ConditionsForRegister from '../components/Service/InternationalCompetition/ConditionsForRegister';
import RegistrationProcess from '../components/Service/InternationalCompetition/RegistrationProcess';
import Share from '../components/Share';
import SideOverlap from './sideOverlap';

export default function CompanyRegistration() {
    return (
        <>
            <Header />
            <CompanyRegistrationHeader />
            <CompanyRegistrationInfo />
            {/* <ConditionsForRegister /> */}
            {/* <RegistrationProcess /> */}
            
            <Share />
            <Footer />
            <SideOverlap/>
        </>
    )
}
